import MountedPrintsFormInputs from './MountedPrintsFormInputs'

export default MountedPrintsFormInputs
